import React from "react";
import { HomepageBanner, HomepageCallout } from "gatsby-theme-carbon";
import HomepageTemplate from "gatsby-theme-carbon/src/templates/Homepage";
import { calloutLink } from "./Homepage.module.scss";

import Carbon from "./carbon.jpg";

const FirstLeftText = () => (
  <img
    id="head-shot"
    alt="Bill Alive"
    src="/images/bill-powell-head-shot.jpg"
  />
);

const FirstRightText = () => (
  <p>
    Hi! 👋 I'm Bill. I <strong>tell stories</strong>, analyze{" "}
    <strong>data</strong>, and craft <strong>tools</strong> and{" "}
    <strong>digital experiences</strong> with elegant <strong>code</strong>.
    <a className={calloutLink} href="/about">
      My story →
    </a>
  </p>
);

// const SecondLeftText = () => <p>Data Science</p>;

// const SecondRightText = () => (
//   <p>
//     I also do data science.
//     <a
//       className={calloutLink}
//       href="https://github.com/carbon-design-system/gatsby-theme-carbon/blob/main/packages/example/src/gatsby-theme-carbon/templates/Homepage.js"
//     >
//       Homepage source →
//     </a>
//   </p>
// );

const BannerText = () => <h1>Portfolio</h1>;

const customProps = {
  Banner: <HomepageBanner renderText={BannerText} image={Carbon} />,
  FirstCallout: (
    <HomepageCallout
      backgroundColor="#030303"
      color="white"
      leftText={FirstLeftText}
      rightText={FirstRightText}
    />
  ),
  SecondCallout: <></>,
};

// spreading the original props gives us props.children (mdx content)
function ShadowedHomepage(props) {
  return <HomepageTemplate {...props} {...customProps} />;
}

export default ShadowedHomepage;
